import React, {useContext, useState} from 'react';
import {
    makeStyles,
    Popover,
    List,
    ListItem,
    Typography,
} from '@material-ui/core';
import {updateState} from "../../../../../services/local_storage";

const useStyles = makeStyles((theme) => ({
    root: {
        width: 200,
        maxWidth: '100%',

    },
    content: {
        margin: theme.spacing(1),
    },
    actions: {
        backgroundColor: theme.palette.background.paper,
        justifyContent: 'flex-end'
    },
}));

const UserPopover = ({anchorEl, handleClose, ...rest}) => {
    const classes = useStyles();
    const handleLogout = async () => {
        await updateState()
        window.location.href = `${window.location.origin}/login`;
        handleClose();
    };
    return (
        <Popover
            {...rest}
            anchorEl={anchorEl}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center'
            }}
        >
            <div className={classes.root}>
                <List>
                    <ListItem
                        button
                        onClick={handleLogout}
                    >
                        <Typography variant={"subtitle1"}>
                            Sign out
                        </Typography>
                    </ListItem>
                </List>
            </div>
        </Popover>
    );
};

export default UserPopover;
